<template>
  <article id="input-select-article">
    <input
      type="text"
      ref="input"
      v-model="searchText"
      :placeholder="placeholder"
      @input="onSearchChange()"
      @keyup.enter="onEnterPressed"
      @blur="onBlur"
      @keydown.up="onKeyPress(-1)"
      @keydown.down="onKeyPress(1)"
    />
    <ul id="list" v-if="filteredItems.length > 0">
      <li
        v-for="(item, index) in filteredItems"
        :key="index"
        @click="select(item)"
        :class="{ selected: index === selectedIndex }"
        @mouseover="selectedIndex = -1"
      >
        <span>{{ item.title }}</span>
      </li>
    </ul>
    <span class="glyphicon glyphicon-search form-control-feedback"></span>
  </article>
</template>

<script>
export default {
  props: {
    searchFn: Function,
    data: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchText: '',
      searchWithFunc: false,
      filteredItems: [],
      selectedIndex: -1,
    };
  },
  created() {
    if (typeof this.searchFn === 'function') {
      this.searchWithFunc = true;
    }
    this.searchText = this.value;
  },
  methods: {
    async onSearchChange() {
      this.emitValue();
      if (this.searchText) {
        const simplifyStr = (str) => {
          // en minuscule, sans accents
          if (str) {
            return str
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '');
          }
          return '';
        };
        const text = simplifyStr(this.searchText);

        // Avec une fonction
        if (this.searchWithFunc) {
          this.filteredItems = await this.searchFn(this.searchText);
        } else {
          // Avec le tableau
          this.filteredItems = this.data.filter((d) =>
            simplifyStr(d).includes(text)
          );
        }
      } else {
        this.filteredItems = [];
      }
    },
    reset() {
      this.filteredItems = [];
      this.selectedIndex = -1;
    },
    /**
     * Selection d'un élément
     * @params {Object} item
     */
    select(item) {
      // On change le text, et on envoie
      this.searchText = item.title;
      this.emitValue();
      this.$emit('select', item);
      this.reset();
    },
    onEnterPressed() {
      if (this.selectedIndex > -1) {
        // Si on est en mode sélection par flèche, on sélectionne l'item
        this.select(this.filteredItems[this.selectedIndex]);
      } else if (this.searchText !== '') {
        // Sinon on envoie le texte actuel
        this.$emit('select', { title: this.searchText });
        this.reset();
      } else {
        // On a fait entrée sur la case vide
        this.$emit('select', null, true);
      }
    },
    onBlur() {
      // TODO
      this.$emit('blur');
    },
    emitValue(text) {
      // On émet pour maj la variable dans le parent
      this.$emit('input', text || this.searchText);
    },
    focus() {
      this.$refs.input.focus();
    },

    // Flèches haut et bas
    onKeyPress(direction = 0) {
      const maxIndex = this.filteredItems.length - 1;
      this.selectedIndex += direction;
      if (this.selectedIndex <= -1) {
        // Si on a remonté en haut de la liste, on remet à -1
        this.selectedIndex = -1;
      } else if (this.selectedIndex > maxIndex) {
        // Si on est déjà en bas, on reste en bas
        this.selectedIndex = maxIndex;
      }
    },
  },
  watch: {
    // On suit value si le parent le change
    value() {
      this.searchText = this.value;
    },
  },
};
</script>

<style lang="scss" scoped src="./InputSelect.scss"></style>
